
/* ==============
   custom-subscriptions.js
   WhiteFit | Shopify Dawn 15.4.1
   Enhances the Shopify Subscriptions app block.
   Features:
   - Compare-at pricing
   - Save percentage pill
   - Optional Most Popular badge
   - Subscription benefits checklist
   - Dynamic selling-plan dropdown updates
   - English/Arabic configurable text
   Optional configuration BEFORE this script loads:
   window.customSubscriptionsText = {
     badge: 'Most Popular',
     save: 'Save {percent}%',
     benefits: [
       'Delivery every 4 weeks',
       'Pause or cancel anytime',
       'Guaranteed during sellouts',
       'Billed monthly'
     ],
     badgeIndex: 0
   };
   Set badgeIndex to -1 to disable the badge.
   =============== */
(function () {
  'use strict';

  if (window.__customSubscriptionsLoaded) return;
  window.__customSubscriptionsLoaded = true;

  var DEFAULTS = {
    badge: 'Most Popular',
    save: 'Save {percent}%',
    benefits: [
      'Delivery every 4 weeks',
      'Pause or cancel anytime',
      'Guaranteed during sellouts',
      'Billed monthly'
    ],
    badgeIndex: 0
  };

  var custom = window.customSubscriptionsText || {};

  var TEXT = {
    badge: typeof custom.badge === 'string'
      ? custom.badge
      : DEFAULTS.badge,

    save: typeof custom.save === 'string'
      ? custom.save
      : DEFAULTS.save,

    benefits: Array.isArray(custom.benefits)
      ? custom.benefits.filter(function (item) {
          return typeof item === 'string' && item.trim();
        })
      : DEFAULTS.benefits,

    badgeIndex: Number.isInteger(custom.badgeIndex)
      ? custom.badgeIndex
      : DEFAULTS.badgeIndex
  };

  var SELECTORS = {
    container:
      '.shopify_subscriptions_app_container, ' +
      '.shopify_subscriptions_app_block',

    group: '.subscription_group',

    subscribeRadio:
      'input[data-radio-type="selling_plan_group"]',

    oneTimeRadio:
      'input[data-radio-type="one_time_purchase"]',

    price: '.in_widget_price',

    wrapper: '.title_and_price_wrapper',

    select: 'select.group_dropdown',

    savePill: '.sub-save-pill',

    benefits: '.sub-benefits'
  };

  var observer = null;
  var scheduled = false;
  var started = false;

  /* ---------- Helpers ---------- */

  function htmlToText(value) {
    if (value == null || value === '') return '';

    var doc = document.createElement('div');

    // Treat data attributes as text, never as executable HTML.
    doc.innerHTML = String(value);

    return (doc.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function toNumber(value) {
    var text = htmlToText(value);

    if (!text) return 0;

    // Supports standard Shopify currency strings such as:
    // AED 1,299.00, $49.00 and 49.00 AED.
    // This assumes commas are thousands separators.
    var normalized = text
      .replace(/[\s\u00a0\u202f]/g, '')
      .replace(/,/g, '')
      .replace(/[^\d.-]/g, '');

    var number = parseFloat(normalized);

    return Number.isFinite(number) && number >= 0
      ? number
      : 0;
  }

  function setText(element, value) {
    if (element && element.textContent !== value) {
      element.textContent = value;
    }
  }

  function getPriceData(radio, select) {
    var option = select &&
      select.selectedOptions &&
      select.selectedOptions[0];

    var source = option &&
      option.hasAttribute('data-variant-price')
      ? option
      : radio;

    return {
      option: option,
      priceText: htmlToText(
        source.getAttribute('data-variant-price')
      ),
      compareText: htmlToText(
        source.getAttribute('data-variant-compare-at-price')
      )
    };
  }

  /* ---------- Compare-at pricing ---------- */

  function ensureCompare(priceElement, compareText, priceText) {
    if (!priceElement) return;

    var existing = priceElement.querySelector('.sub-compare');

    var price = toNumber(priceText);
    var compare = toNumber(compareText);

    var shouldShow =
      Boolean(compareText) &&
      compare > price &&
      price > 0;

    if (!shouldShow) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      existing = document.createElement('s');
      existing.className = 'sub-compare';
      priceElement.appendChild(existing);
    }

    setText(existing, compareText);
  }

  /* ---------- Save percentage ---------- */

  function getSavePercentage(priceText, compareText, option) {
    var price = toNumber(priceText);
    var compare = toNumber(compareText);

    if (price > 0 && compare > price) {
      return Math.round((1 - price / compare) * 100);
    }

    // Some apps expose the saving in the plan option label.
    if (option) {
      var match = option.textContent.match(
        /(?:^|\D)(\d{1,2})\s*%/
      );

      if (match) {
        var percentage = parseInt(match[1], 10);

        return percentage > 0 && percentage < 100
          ? percentage
          : 0;
      }
    }

    return 0;
  }

  function ensureSavePill(group, wrapper) {
    var pill = group.querySelector(SELECTORS.savePill);

    if (!pill) {
      pill = document.createElement('span');
      pill.className = 'sub-save-pill';

      if (wrapper && wrapper.parentNode === group) {
        wrapper.insertAdjacentElement('afterend', pill);
      } else {
        group.insertBefore(pill, group.firstChild);
      }
    }

    return pill;
  }

  /* ---------- Benefits checklist ---------- */

  function ensureBenefits(group) {
    var list = group.querySelector(SELECTORS.benefits);

    if (!TEXT.benefits.length) {
      if (list) list.remove();
      return;
    }

    if (!list) {
      list = document.createElement('ul');
      list.className = 'sub-benefits';
      group.appendChild(list);
    }

    // Update existing items without duplicating the list.
    if (
      list.children.length !== TEXT.benefits.length ||
      Array.prototype.some.call(list.children, function (item, index) {
        return item.textContent !== TEXT.benefits[index];
      })
    ) {
      var fragment = document.createDocumentFragment();

      TEXT.benefits.forEach(function (benefit) {
        var item = document.createElement('li');
        item.textContent = benefit;
        fragment.appendChild(item);
      });

      list.replaceChildren(fragment);
    }
  }

  /* ---------- One-time purchase ---------- */

  function enhanceOneTime(group) {
    var radio = group.querySelector(SELECTORS.oneTimeRadio);

    if (!radio) return;

    var priceElement = group.querySelector(SELECTORS.price);

    ensureCompare(
      priceElement,
      htmlToText(radio.getAttribute('data-variant-compare-at-price')),
      htmlToText(radio.getAttribute('data-variant-price'))
    );

    // Never add subscription-only elements to one-time purchases.
    var pill = group.querySelector(SELECTORS.savePill);
    var benefits = group.querySelector(SELECTORS.benefits);

    if (pill) pill.remove();
    if (benefits) benefits.remove();

    group.removeAttribute('data-badge');
  }

  /* ---------- Subscription plan ---------- */

  function enhanceSubscription(group, radio, badgeIndex) {
    var select = group.querySelector(SELECTORS.select);
    var data = getPriceData(radio, select);
    var priceElement = group.querySelector(SELECTORS.price);

    ensureCompare(
      priceElement,
      data.compareText,
      data.priceText
    );

    // Only the configured subscription option receives the badge.
    if (
      TEXT.badge &&
      TEXT.badgeIndex >= 0 &&
      badgeIndex === TEXT.badgeIndex
    ) {
      if (group.getAttribute('data-badge') !== TEXT.badge) {
        group.setAttribute('data-badge', TEXT.badge);
      }
    } else {
      group.removeAttribute('data-badge');
    }

    var percentage = getSavePercentage(
      data.priceText,
      data.compareText,
      data.option
    );

    var pill = ensureSavePill(
      group,
      group.querySelector(SELECTORS.wrapper)
    );

    var saveText = percentage > 0
      ? TEXT.save.replace(/\{percent\}/g, String(percentage))
      : '';

    setText(pill, saveText);

    ensureBenefits(group);
  }

  /* ---------- Container enhancement ---------- */

  function enhance(container) {
    var groups = container.querySelectorAll(SELECTORS.group);
    var subscriptionIndex = 0;

    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];

      var subscriptionRadio = group.querySelector(
        SELECTORS.subscribeRadio
      );

      if (subscriptionRadio) {
        enhanceSubscription(
          group,
          subscriptionRadio,
          subscriptionIndex
        );

        subscriptionIndex++;
      } else {
        enhanceOneTime(group);
      }
    }
  }

  function enhanceAll() {
    var containers = document.querySelectorAll(SELECTORS.container);
    var processed = [];

    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];

      // Avoid enhancing the same app block through a nested wrapper.
      var alreadyProcessed = processed.some(function (parent) {
        return parent.contains(container);
      });

      if (!alreadyProcessed) {
        processed.push(container);
      }
    }

    processed.forEach(enhance);
  }

  /* ---------- Lifecycle and dynamic app updates ---------- */

  function run() {
    scheduled = false;

    try {
      enhanceAll();
    } catch (error) {
      if (window.console && console.error) {
        console.error('[custom-subscriptions]', error);
      }
    }
  }

  function schedule() {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(run);
  }

  function init() {
    if (started) return;
    started = true;

    // Dawn product information and app blocks can render dynamically.
    var root = document.body;

    if (root && window.MutationObserver) {
      observer = new MutationObserver(function (mutations) {
        var shouldUpdate = mutations.some(function (mutation) {
          var target = mutation.target;

          if (
            target.nodeType === 1 &&
            target.closest &&
            target.closest('.sub-benefits, .sub-save-pill, .sub-compare')
          ) {
            return false;
          }

          return true;
        });

        if (shouldUpdate) schedule();
      });

      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'data-variant-price',
          'data-variant-compare-at-price',
          'checked',
          'selected'
        ]
      });
    }

    document.addEventListener('change', function (event) {
      var target = event.target;

      if (
        target &&
        target.closest &&
        target.closest(SELECTORS.container)
      ) {
        schedule();
      }
    });

    // Initial enhancement.
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }

  window.addEventListener('load', schedule, { once: true });

})();
